module.exports = __webpack_public_path__ + "static/img/bj.2701cd5e.png";